/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import {
  Avatar,
  Box,
  Card,
  Grid,
  Typography,
  useMediaQuery,
} from '@mui/material';
import UserImg from 'assets/dummy/profile.svg';
import GreenDot from 'assets/icons/greendot.svg';
import { Dot } from 'component/BuyersMarketplace/Marketplaceicons';
import LabelHeader from 'component/LabelHeader/LabelHeader';
import moment from 'moment';
import { poppins300, poppins400 } from 'theme/common.style';
import CounterTimer from './CounterTimer';
import {
  counterBtn,
  liveAvatarStatus,
  offerCenterCont,
  offerValue,
} from './LiveOfferStatus.style';
import { useTheme } from '@emotion/react';
import { dateformatBasedOnUserType } from 'api/apiService';
import { useState } from 'react';
import { HighStar } from 'modules/private/ViewDashBoardDetails/ViewDashboardDetails';
import { highStarStyle } from 'modules/private/ViewDashBoardDetails/ViewDashboardDetails.style';
import NameTooltip from 'component/Common/NameTooltip';

function LiveOfferStatus(props) {
  const data = props?.profileDetails?.PropertyDetails;
  const buyerdata = props?.profileDetails?.BuyerRegisterDetails;
  const buyerregdata = props?.profileDetails;
  const isWinner = props?.profileDetails?.PropertyDetails?.isWinner;
  const {
    profileDetails,
    getListInfo,
    Highest,
    activityfun,
    setPublish,
    offerdata,
    stage2AcceptanceCertificate,
    setStage2AcceptanceCertificate,
  } = props;
  // const data = profileDetails?.PropertyDetails;
  const date = data?.liveOfferLastUpdated;
  // const vendorData = profileDetails?.PropertyDetails
  const dateupdated = moment(data?.highestOfferLastUpdated).format(
    'DD-MM-YYYY'
  );

  const userType = JSON.parse(localStorage.getItem('userType'))?.userType;

  const primaryUserTypeValue = JSON.parse(localStorage.getItem('primaryUser'));

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  const textStyle = {
    visibility: 'hidden',
    backgroundColor: '#fff',
    color: '#000',
    textAlign: 'center',
    borderRadius: '6px',
    padding: '5px 10px',
    position: 'absolute',
    zIndex: 1,
    bottom: '125%',
    left: '50%',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap',
    boxShadow: '8px 8px 8px 8px rgba(0, 0, 0, 0.1)',
    fontFamily: 'Poppins',
    fontSize: '10px',
  };
  const containerStyle = {
    position: 'relative',
    display: 'inline-block',
  };
  const textVisibleStyle = {
    ...textStyle,
    visibility: 'visible',
    opacity: 1,
    transition: 'opacity 0.3s',
  };
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Card
      style={{
        borderRadius: matchessm ? '10px' : '5px',
        boxShadow: 'none',
        marginTop: '25px',
        marginBottom: '0px',
        // marginLeft: "25px",
        border: '0.5px solid #D9D9D9',
        // width: "332px",
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          border: 'none',
        }}
      >
        <Box
          sx={{
            padding: '18px',
            borderBottom: '0.5px solid #F0F0F0',
            marginBottom: '10px',
          }}
        >
          <LabelHeader labelValue="Highest Offer" />

          <Box sx={offerCenterCont}>
            {data?.highestOffer ? (
              <>
                <Grid
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: 500,
                        fontSize: '30px',
                        color: '#112347',
                        textAlign: 'center',
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      {data?.highestOfferIsFinal === 1 && (
                        <div
                          style={containerStyle}
                          onMouseEnter={() => setIsHovered(true)}
                          onMouseLeave={() => setIsHovered(false)}
                        >
                          <HighStar style={highStarStyle} />
                          <span
                            style={isHovered ? textVisibleStyle : textStyle}
                          >
                            Best & Final Offer
                          </span>
                        </div>
                      )}
                      {data?.highestOffer}
                    </Typography>
                  </Box>
                  <Box>
                    {data?.highestOfferIsConditional == 0 ? (
                      <Typography
                        sx={{
                          width: '9px',
                          height: '9px',
                        }}
                      >
                        <Avatar
                          alt="Remy Sharp"
                          src={GreenDot}
                          sx={{
                            width: '18px',
                            height: '18px',
                          }}
                        />
                      </Typography>
                    ) : (
                      <Dot />
                    )}
                  </Box>
                </Grid>

                <Grid
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        ...poppins400,
                        fontSize: '12px',
                        color: 'rgba(17, 35, 71, 0.5)',
                      }}
                    >
                      Last Updated :&nbsp;
                      {data?.highestOfferLastUpdated
                        ? dateformatBasedOnUserType(
                            data?.highestOfferLastUpdated,
                            primaryUserTypeValue
                          )
                        : ''}
                    </Typography>
                  </Box>
                </Grid>

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    minWidth: 0,
                  }}
                >
                  <Box
                    sx={{
                      flexShrink: 0,
                      mr: '6px',
                    }}
                  >
                    {data?.highestOfferBuyerProfile == '' ||
                    data?.highestOfferBuyerProfile == null ||
                    userType == 'Vendor' ? (
                      <Avatar
                        sx={{
                          fontFamily: 'Poppins',
                          fontSize: '18px',
                          backgroundColor: '#666666',
                        }}
                      >
                        {data?.highestOfferBuyerNameInitial}
                      </Avatar>
                    ) : (
                      <Avatar
                        sx={{
                          fontFamily: 'Poppins',
                          fontSize: '20px',
                          backgroundColor: '#666666',
                        }}
                        alt={data?.highestOfferBuyerName}
                        src={data?.highestOfferBuyerProfile}
                      />
                    )}
                  </Box>
                  <Box
                    sx={{
                      minWidth: 0,
                      maxWidth: 'calc(100% - 42px)',
                      overflow: 'hidden',
                    }}
                  >
                    <NameTooltip
                      name={data?.highestOfferBuyerName}
                      surname={
                        Highest
                          ? data?.highestOfferBuyerSurName
                              ?.charAt(0)
                              ?.toUpperCase() || ''
                          : ''
                      }
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Poppins',
                          fontWeight: 300,
                          color: '#112347',
                          display: 'block',
                          width: '100%',
                          minWidth: 0,
                          maxWidth: '100%',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          cursor: 'pointer',
                        }}
                      >
                        {Highest
                          ? `${data?.highestOfferBuyerName || ''} ${
                              data?.highestOfferBuyerSurName
                                ?.charAt(0)
                                ?.toUpperCase() || ''
                            }`
                          : data?.highestOfferBuyerName || ''}
                      </Typography>
                    </NameTooltip>
                  </Box>
                </Box>
              </>
            ) : (
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                }}
              >
                No offer available
              </Typography>
            )}
          </Box>

          {primaryUserTypeValue == 'Agent' ||
          primaryUserTypeValue == 'Vendor' ? (
            data?.highestOfferStatus == 'Counter Offer' ? (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100%',
                  marginTop: '18px',
                }}
              >
                <Typography
                  sx={{
                    ...poppins300,
                    fontSize: '14px',
                    ...counterBtn,
                  }}
                  component="div"
                >
                  Counter offer submitted
                </Typography>
              </Box>
            ) : (
              ''
            )
          ) : (
            ''
          )}
        </Box>

        <CounterTimer
          dataProfileDetails={profileDetails}
          profileDetails={profileDetails?.PropertyDetails}
          getListInfo={getListInfo}
          Highest={Highest}
          buyerdata={buyerdata}
          activityfun={activityfun}
          setPublish={setPublish}
          buyerregdata={buyerregdata}
          offerdata={offerdata}
          isWinner={isWinner}
          stage2AcceptanceCertificate={stage2AcceptanceCertificate}
          setStage2AcceptanceCertificate={setStage2AcceptanceCertificate}
        />

        {/* counter timer end */}
      </Box>
    </Card>
  );
}

LiveOfferStatus.propTypes = {};

export default LiveOfferStatus;
